// extracted by mini-css-extract-plugin
module.exports = {"Item":"Game_Item__1CCyp","Name":"Game_Name__4rPnI"};